export * from './quick-kyc.types'
export * from './quick-kyc.container'
